import { z } from "zod";

import { Operator, StringOperator } from "../operators.ts";
import type { IResolvableStringValue } from "../values.ts";
import { ResolvableStringValue } from "../values.ts";
import type { IBinaryCondition } from "./common.ts";
import { binaryCondition } from "./common.ts";

// Zod value schema for string conditions
const StringValue = z.union([z.string(), ResolvableStringValue]);

// Zod schemas with type discriminator
export const StringBinaryCondition = binaryCondition(z.literal("string"), StringOperator, StringValue);
export type StringBinaryCondition = z.infer<typeof StringBinaryCondition>;

export const StringCondition = z.discriminatedUnion("operator", [
  binaryCondition(z.literal("string"), z.literal(Operator.EQ), StringValue),
  binaryCondition(z.literal("string"), z.literal(Operator.NE), StringValue),
  binaryCondition(z.literal("string"), z.literal(Operator.Contains), StringValue),
  binaryCondition(z.literal("string"), z.literal(Operator.NotContains), StringValue),
  binaryCondition(z.literal("string"), z.literal(Operator.Matches), StringValue),
  binaryCondition(z.literal("string"), z.literal(Operator.NotMatches), StringValue),
]);
export type StringCondition = z.infer<typeof StringCondition>;

// Interfaces for complex types (verified to match schemas)
export interface IStringBinaryCondition extends IBinaryCondition<
  | typeof Operator.EQ
  | typeof Operator.NE
  | typeof Operator.Contains
  | typeof Operator.NotContains
  | typeof Operator.Matches
  | typeof Operator.NotMatches,
  string | IResolvableStringValue
> {
  type: "string";
}

// Type compatibility assertion - compile-time check that inferred type matches interface
type _AssertBinaryCompatible = StringBinaryCondition extends IStringBinaryCondition ? true : never;
const _binaryCheck: _AssertBinaryCompatible = true;
void _binaryCheck;
